var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationMessage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,3.75 L4.5,3.75 C4.0875,3.75 3.75,4.0875 3.75,4.5 L3.75,9 C3.75,9.4125 4.0875,9.75 4.5,9.75 L9.75,9.75 L11.25,11.25 L11.25,4.5 C11.25,4.0875 10.9125,3.75 10.5,3.75 Z M9.75,8.25 L5.25,8.25 L5.25,7.5 L9.75,7.5 L9.75,8.25 Z M9.75,7.125 L5.25,7.125 L5.25,6.375 L9.75,6.375 L9.75,7.125 Z M9.75,6 L5.25,6 L5.25,5.25 L9.75,5.25 L9.75,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-26.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotificationMessage",
    transform: "translate(26.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    fill: "#2C91D0",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/editor/insert_comment_24px",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) ",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationMessage);
export default __webpack_public_path__ + "static/media/icNotificationMessage.89a9fb023812b14688a93076a322c8df.svg";
export { ForwardRef as ReactComponent };